<!-- Title -->
<div class="text-center">
  <h1>Move in inspection - Checklist</h1>
</div>

<!-- Condition Checklist Content -->
<div id="condition-checklist">

  <div class="container content-box module-content">
    <!-- Form -->
    <form name="form" (submit)="f.form.valid && submitForm()" #f="ngForm" novalidate *ngIf="data.loaded">
      <fieldset [disabled]="submitting || data.readonly">
        <!-- Date Moved In -->
        <div class="row mb-4">
          <div class="date-moved-in col-md-3">
            <label>Date Moved In:</label>
            <div class="input-group date_container">
                <input class="form-control mb-2" matInput [matDatepicker]="picker" id="dateMovedIn" name="dateMovedIn" [min]="minDateMovedIn" [max]="maxDateMovedIn" [(ngModel)]="data.dateMovedIn" (ngModelChange)="data.changed = true" #dateMovedIn="ngModel" [ngClass]="{ 'is-invalid': f.submitted && dateMovedIn.invalid }">

                <!-- Date Picker -->
                <mat-datepicker startView="month" #picker></mat-datepicker>
                <mat-datepicker-toggle class="icon" matSuffix [for]="picker"></mat-datepicker-toggle>

                <!-- Invalid -->
                <div *ngIf="f.submitted && dateMovedIn.invalid" class="invalid-feedback">
                </div>
            </div>
          </div>
        </div>

        <!-- Checklist -->
        <div class="checklist mb-4" *ngIf="data.checklist">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th scope="col" class="th-question"></th>
                <th scope="col" class="th-answer rotated-cell" *ngFor="let option of options">
                  <span>{{option.label}}</span>
                </th>
                <th scope="col" class="th-comments rotated-cell"><span>Any comments?</span></th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let q of data.checklist">
                <ng-container *ngIf="q.answer as table">
                  <ng-container *ngFor="let question of table.questions; let qindex=index">
                    <tr [ngClass]="[qindex === 0 ? 'primary' : 'secondary']">
                      <td class="td-question" scope="row">{{question}}</td>

                      <td class="td-answer text-center" *ngFor="let option of table.options; let oindex=index">
                        <div class="form-group radio-group" [class.has-error]="f.submitted && radio.invalid" (keypress)="table_radioGroup_keypress(q.answer, qindex, $event)">
                          <input type="radio" class="btn-check" name="table{{q.questionNumber}}_options{{qindex}}" id="table{{q.questionNumber}}_options{{qindex}}_{{oindex}}" autocomplete="off"
                            [(ngModel)]="table.answers[qindex]" (ngModelChange)="data.changed = true" #radio="ngModel" [value]="option">
                          <label class="custom btn" for="table{{q.questionNumber}}_options{{qindex}}_{{oindex}}"
                            [ngClass]="[table.answers[qindex] === option ? 'btn-secondary' : 'btn-outline-secondary']"
                            (click)="table_radio_click(q.answer, option, qindex, $event)">{{options[oindex].value}}</label>
                        </div>
                      </td>

                      <td class="td-comments">
                        <button type="button" class="custom btn add-comment" (click)="table_toggleComment(q, qindex)"
                            [matTooltip]="ui.comment(table.comments[qindex]).show !== true ? 'Add comments' : 'Remove comments'" [matTooltipShowDelay]="1000">
                          <mdb-icon far icon="comment-alt" class="icon-comment" size="lg"></mdb-icon>
                          <mdb-icon fas icon="plus" class="icon-plus" size="xs" *ngIf="ui.comment(table.comments[qindex]).show !== true"></mdb-icon>
                          <mdb-icon fas icon="minus" class="icon-minus" size="xs" *ngIf="ui.comment(table.comments[qindex]).show === true"></mdb-icon>
                        </button>
                      </td>
                    </tr>
                    <tr *ngIf="ui.comment(table.comments[qindex]).show">
                      <td colspan="7">
                        <textarea class="form-control comments" name="comments" rows="2" placeholder="Enter comments..."
                          [(ngModel)]="ui.comment(table.comments[qindex]).text" [ngModelOptions]="{ standalone: true }"
                          (ngModelChange)="data.changed = true">
                        </textarea>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>

        <!-- Acknowledge Smoke Detector -->
        <div class="acknowledge-smoke-detector mb-4">
          <input type="checkbox" name="ackSmokeDetector" id="ackSmokeDetector" class="mb-2" name="ackSmokeDetector"
            [(ngModel)]="data.ackSmokeDetector" (ngModelChange)="data.changed = true" name="ackSmokeDetector" #ackSmokeDetector="ngModel"
            [ngClass]="{ 'is-invalid': f.submitted && ackSmokeDetector.invalid }" />

          <label for="ackSmokeDetector" class="ml-2">
            Tenants acknowledge that the smoke detector was tested in their presence and were found to be in working order and
            that its operation was explained to them. Tenants agree to test the detector at least every other week and to
            report any problems to Owners in writing. If the detector is battery powered, Tenants agree to replace the battery
            as necessary with a new ALKALINE battery (unless applicable laws require otherwise).
          </label>

          <!-- Invalid -->
          <div *ngIf="f.submitted && ackSmokeDetector.invalid" class="invalid-feedback">
          </div>
        </div>
      </fieldset>

      <div class="invalid-feedback summary text-center mb-4" *ngIf="f.submitted && f.form.invalid">
        Please fix above errors highlighted in red.
      </div>

      <div class="buttons container mt-2">
        <!-- Back to List -->
        <button type="button" class="btn waves-dark" (click)="goBack()"><i class="fas fa-angle-left mr-3"></i> Back to List</button>

        <!-- Save -->
        <button type="submit" *ngIf="!data.readonly" class="btn waves-dark">Save <i class="fas fa-angle-right ml-3"></i></button>
      </div>
    </form>
  </div>
</div>
